import React from 'react';
import { Loader } from '@vds/loaders';

const SpinnerComponent = () => {
    return(
        <div className="loading-spinner">
            <Loader active fullscreen disableFocusLock/>
        </div>
    );
}

export default SpinnerComponent;